export default __webpack_public_path__ + "images/cm-7578267e8568b1490427bb8db78871b6.svg";